import React, { useState } from 'react'
import cn from 'classnames'

type WidgetItemPropsType = {
  title: React.ReactNode
}

export const WidgetItem: React.FC<WidgetItemPropsType> = ({
  title,
  children,
}) => {
  const [visible, setVisible] = useState<boolean>(true)

  const toggleVisible = () => setVisible(!visible)

  return (
    <div className="widget-filters__item">
      <div
        className={cn('filter', { 'filter--opened': visible })}
        data-collapse-item
      >
        <button
          type="button"
          className="filter__title"
          data-collapse-trigger
          onClick={toggleVisible}
        >
          {title}
          <span className="filter__arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="7px">
              <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
            </svg>
          </span>
        </button>
        <div className="filter__body" data-collapse-content>
          <div className="filter__container">{children}</div>
        </div>
      </div>
    </div>
  )
}
